import { useGetTicketsInProgressCustomerLookupCountQuery } from 'services/tickets';
import { FindAllTicketsInProgressCustomerLookupDto } from 'types/dto/ticket/find-all-tickets-in-progress-customer-lookup.dto';

export function useTicketsInProgressCustomerLookupCount(
  params: Omit<FindAllTicketsInProgressCustomerLookupDto, 'pageIndex' | 'pageSize'>
) {
  const {
    customerName,
    customerAddress,
    meterSerialNumber,
    customerCode,
    routeCode,
    meterPointCode,
    organizationUnitCode,
    wardId,
    districtId,
    ticketId,
    customerPhoneNumber,
    administrativeUnitId,
    contactId
  } = params;

  const shouldFetch = !!(
    customerName ||
    customerAddress ||
    meterSerialNumber ||
    customerCode ||
    routeCode ||
    meterPointCode ||
    organizationUnitCode ||
    wardId ||
    districtId ||
    ticketId ||
    customerPhoneNumber ||
    administrativeUnitId ||
    contactId
  );

  const queryParams = shouldFetch
    ? {
        customerName,
        customerAddress,
        meterSerialNumber,
        customerCode,
        routeCode,
        meterPointCode,
        organizationUnitCode,
        wardId,
        districtId,
        ticketId,
        customerPhoneNumber,
        administrativeUnitId,
        contactId
      }
    : {
        customerName: '',
        customerAddress: '',
        meterSerialNumber: '',
        customerCode: '',
        routeCode: '',
        meterPointCode: '',
        organizationUnitCode: '',
        wardId: undefined,
        districtId: undefined,
        ticketId: '',
        customerPhoneNumber: '',
        administrativeUnitId: 0,
        contactId: 0
      };

  const { data: count } = useGetTicketsInProgressCustomerLookupCountQuery(queryParams, {
    skip: !shouldFetch
  });

  return {
    count: shouldFetch ? count?.data || 0 : 0
  };
}
